'use client';
import React, { useState } from 'react';
import { Box, List, ListItem } from '@mui/material';
import IslandMenuButton from '../IslandMenuButton';
import SmoothScrollLink from '@components/SmoothScrollLink';

import cn from './style.module.scss';
type MenuItem = {
  label: string;
  id: string;
  submenu?: MenuItem[];
};
type IslandSidebarMenuProps = {
  t?: any;
  navigationItems?: MenuItem[];
  menuClassName?: string;
};
const MenuItemRenderer: React.FC<{
  item: MenuItem;
  path: string;
  openItems: Set<string>;
  toggleItem: (path: string) => void;
  depth?: number;
}> = ({ item, path, openItems, toggleItem, depth = 0 }) => {
  const hasSubmenu = Boolean(item.submenu?.length);
  const isOpen = depth === 0 || openItems.has(path);
  return (
    <ListItem
      className={cn.listItem}
      style={{ paddingLeft: `${depth * 12}px` }}
    >
      {hasSubmenu ? (
        <>
          <Box className={cn.dropdownItem} onClick={() => toggleItem(path)}>
            <label>{item.label}</label>
          </Box>

          {isOpen && (
            <List className={cn.dropdownMenu}>
              {item.submenu!.map((subItem, index) => (
                <MenuItemRenderer
                  key={index}
                  item={subItem}
                  path={`${path}-${index}`}
                  openItems={openItems}
                  toggleItem={toggleItem}
                  depth={depth + 1}
                />
              ))}
            </List>
          )}
        </>
      ) : (
        <Box className={cn.dropdownItem}>
          <SmoothScrollLink href={item.id} transition>
            {item.label}
          </SmoothScrollLink>
        </Box>
      )}
    </ListItem>
  );
};

/* ---------------- MAIN COMPONENT ---------------- */

export default function IslandSidebarMenu({
  t,
  navigationItems = [],
  menuClassName,
}: IslandSidebarMenuProps) {
  const [openItems, setOpenItems] = useState<Set<string>>(new Set());

  const toggleItem = (path: string) => {
    setOpenItems((prev) => {
      const updated = new Set(prev);
      updated.has(path) ? updated.delete(path) : updated.add(path);
      return updated;
    });
  };
  const showRegisterButton = Boolean(t?.hideRegisterButtonInHeader);
  return (
    <Box className={`${cn.islandSidebarWrapper} ${menuClassName ?? ''}`}>
      <List className={cn.islandNavigationList}>
        {navigationItems.map((item, index) => (
          <MenuItemRenderer
            key={index}
            item={item}
            path={index.toString()}
            openItems={openItems}
            toggleItem={toggleItem}
          />
        ))}
      </List>
      {showRegisterButton ? (
        <Box className={cn.registerWrapper}>
          <IslandMenuButton t={t} />
        </Box>
      ) : null}
    </Box>
  );
}
